module.exports = __webpack_public_path__ + "img/consult.be994db3.png";